(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const frameMap = new WeakMap();

  const queue = (section) => {
    if (!section || frameMap.get(section)) return;
    const frame = requestAnimationFrame(() => {
      frameMap.delete(section);
      sync(section);
    });
    frameMap.set(section, frame);
  };

  const sync = (section) => {
    const arrows = Array.from(section.querySelectorAll('.alp-featured-story__arrow'));
    if (!arrows.length) return;

    if (!desktop.matches) {
      arrows.forEach((arrow) => {
        arrow.style.removeProperty('top');
        arrow.style.removeProperty('transform');
      });
      return;
    }

    const media =
      section.querySelector('.alp-featured-story__slide.is-active .alp-featured-story__media') ||
      section.querySelector('.alp-featured-story__slide[aria-hidden="false"] .alp-featured-story__media') ||
      section.querySelector('.alp-featured-story__media');

    if (!media) return;

    const parent = arrows[0].offsetParent || section;
    const mediaRect = media.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const centerY = mediaRect.top - parentRect.top + mediaRect.height / 2;

    arrows.forEach((arrow) => {
      arrow.style.top = `${Math.round(centerY)}px`;
      arrow.style.transform = 'translateY(-50%)';
    });
  };

  const bind = (section) => {
    if (!section || section.dataset.hemiFeaturedArrowPositionBound === 'true') return;
    section.dataset.hemiFeaturedArrowPositionBound = 'true';

    queue(section);

    section.addEventListener('click', (event) => {
      if (!event.target.closest('[data-afs-previous], [data-afs-next]')) return;
      setTimeout(() => queue(section), 0);
      setTimeout(() => queue(section), 160);
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => queue(section));
      observer.observe(section);
      section.querySelectorAll('.alp-featured-story__media').forEach((media) => observer.observe(media));
    }

    if ('MutationObserver' in window) {
      new MutationObserver(() => queue(section)).observe(section, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'aria-hidden', 'src', 'srcset']
      });
    }
  };

  const bindAll = () => {
    document.querySelectorAll('.alp-featured-story').forEach(bind);
  };

  document.addEventListener('DOMContentLoaded', bindAll);
  document.addEventListener('shopify:section:load', bindAll);
  window.addEventListener('load', bindAll, { passive: true });
  window.addEventListener('resize', bindAll, { passive: true });

  if (desktop.addEventListener) {
    desktop.addEventListener('change', bindAll);
  }
})();